import React from "react";
import { Navigate } from "react-router-dom";

// Lazy load all components first
const Home = React.lazy(() => import("../pages/home"));
const Profile = React.lazy(() => import("../pages/Profile"));
const Mysumo = React.lazy(() => import("../pages/Profile/my-sumo"));
const Landing = React.lazy(() => import("../pages/home/landing"));
const Landingtakeaway = React.lazy(() =>
  import("../pages/home/landingtakeaway")
);
const Home1 = React.lazy(() => import("../pages/home1"));
const HybridAuthFlow = React.lazy(() => import("../pages/Auth/HybridAuthFlow"));
const ResetPassword = React.lazy(() => import("../pages/Auth/reset-password"));
const Upload = React.lazy(() => import("../pages/Profile/account/upload"));
const DealsDetails = React.lazy(() => import("../pages/deals-details"));
const Deals = React.lazy(() => import("../pages/Deals"));
const DealEdit = React.lazy(() => import("../pages/Deals/DealEdit"));
const Account = React.lazy(() => import("../pages/Profile/account"));
const Order = React.lazy(() => import("../pages/order"));
const Payments = React.lazy(() => import("../pages/order/payments"));
const Confirm = React.lazy(() => import("../pages/order/confirm"));
const Confirm1 = React.lazy(() => import("../pages/order/confirm1"));
const Marketing = React.lazy(() => import("../pages/Profile/marketing"));
const Header = React.lazy(() => import("../components/Header"));
const Footer = React.lazy(() => import("../components/Footer"));
const Questlonnalre = React.lazy(() => import("../pages/home/questlonnalre"));
const Reports = React.lazy(() => import("../pages/Reports"));
const Dashboard = React.lazy(() => import("../pages/Dashboard"));
const Questlonnalretab = React.lazy(() =>
  import("../pages/home/questlonnalre-tab")
);
const Questlonnalretabtakeaway = React.lazy(() =>
  import("../pages/home/questlonnalre-tab-takeaway")
);
const NotFound = React.lazy(() => import("../pages/not-found"));
const Influencer = React.lazy(() => import("../pages/Influencer"));
const InfluencerProfileEdit = React.lazy(() =>
  import("../pages/Influencer/edit")
);
const CollaborationProposal = React.lazy(() =>
  import("../pages/CollaborationProposal")
);
const Proposals = React.lazy(() => import("../pages/Influencer/proposals"));

// Commission & Payout Pages
const MerchantCommissionDashboard = React.lazy(() =>
  import("../pages/Merchant/commissions")
);
const MerchantTransactions = React.lazy(() =>
  import("../pages/Merchant/commissions/transactions")
);
const InfluencerCollaborations = React.lazy(() =>
  import("../pages/Influencer/collaborations")
);
const InfluencerDashboard = React.lazy(() =>
  import("../pages/Influencer/dashboard")
);
const MerchantProposals = React.lazy(() =>
  import("../pages/MerchantProposals")
);
const InfluencerTransactions = React.lazy(() =>
  import("../pages/Influencer/transactions")
);
const InfluencerOrders = React.lazy(() =>
  import("../pages/Influencer/orders")
);
const TransactionDetail = React.lazy(() =>
  import("../pages/Influencer/transactions/detail")
);
const PayoutRequest = React.lazy(() => import("../pages/Influencer/payout"));
const PayoutHistory = React.lazy(() => import("../pages/Influencer/payouts"));
const PromoteDeals = React.lazy(() => import("../pages/PromoteDeals"));
const Notifications = React.lazy(() => import("../pages/Notifications"));
const ExclusiveDeals = React.lazy(() =>
  import("../pages/Influencer/ExclusiveDeals")
);
const InfluencerDrafts = React.lazy(() =>
  import("../pages/Influencer/Drafts")
);
const CreateExclusiveDeal = React.lazy(() =>
  import("../pages/Influencer/CreateExclusiveDeal")
);
const InfluencerKyc = React.lazy(() =>
  import("../pages/Influencer/kyc")
);
const MerchantDealProposals = React.lazy(() =>
  import("../pages/Merchant/DealProposals")
);
const MerchantPayoutHistory = React.lazy(() =>
  import("../pages/Merchant/payouts")
);
const Orders = React.lazy(() => import("../pages/Orders"));
const OrderDetails = React.lazy(() => import("../pages/OrderDetails"));
const PrivacyPolicy = React.lazy(() => import("../pages/Privacy"));
const TermsAndCondition = React.lazy(() => import("../pages/TermsAndConditions"));
const GetInTouch = React.lazy(() => import("../pages/GetInTouch"));
const Impersonate = React.lazy(() => import("../pages/Impersonate"));
const ContinueSession = React.lazy(() => import("../pages/ContinueSession"));
// Common routes accessible by all users (logged in or not)
const publicRoutes = [
  {
    path: "/login",
    name: "Login",
    title: "Login",
    element: <HybridAuthFlow />,
  },
  // Legacy auth routes are preserved but redirected to the new hybrid flow.
  {
    path: "/signup",
    name: "Signup",
    title: "Sign Up",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/signin",
    name: "Signin",
    title: "Sign In",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    title: "Reset Password",
    element: <ResetPassword />,
    noLayout: true,
  },
  {
    path: "/auth/signup",
    name: "Login",
    title: "Login",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/varification",
    name: "Verification",
    title: "Verification",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/auth/login-with-otp",
    name: "LoginWithOTP",
    title: "Sign In with OTP",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/auth/login-otp-verification",
    name: "LoginOTPVerification",
    title: "Verify OTP",
    element: <Navigate to="/login" replace />,
  },

  {
    path: "/notifications",
    name: "Notifications",
    title: "Notifications",
    element: <Notifications />,
    protected: true,
  },

  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    title: "Privacy Policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    name: "TermsAndCondition",
    title: "Terms and Conditions",
    element: <TermsAndCondition />,
  },
  {
    path: "/delete-account",
    name: "DeleteAccount",
    title: "Delete Your Account",
    element: <GetInTouch />,
  },
  {
    path: "/get-in-touch",
    name: "GetInTouchAlt",
    title: "Get in Touch",
    element: <GetInTouch />,
  },
  {
    path: "/impersonate",
    name: "Impersonate",
    title: "Impersonation Handshake",
    element: <Impersonate />,
    noLayout: true,
  },
  {
    path: "/continue-session",
    name: "ContinueSession",
    title: "Continue Session",
    element: <ContinueSession />,
    noLayout: true,
  },
];

// Routes only for influencer role
const influencerRoutes = [
  {
    path: "/",
    name: "Home",
    title: "Home",
    element: <Influencer />,
    protected: true,
  },
  {
    path: "/influencer",
    name: "Influencer",
    title: "Influencer",
    element: <Influencer />,
    protected: true,
  },
  {
    path: "/influencer/:id",
    name: "InfluencerProfile",
    title: "Influencer Profile",
    element: <Influencer />,
    protected: true,
  },
  {
    path: "/influencer/profile/edit",
    name: "InfluencerProfileEdit",
    title: "Edit Influencer Profile",
    element: <InfluencerProfileEdit />,
  },
  {
    path: "/incoming-requests",
    name: "IncomingRequests",
    title: "Incoming Requests",
    element: <Proposals />,
    protected: true,
  },
  {
    path: "/influencer/proposals",
    name: "Proposals",
    title: "Collaboration Proposals",
    element: <Proposals />,
    protected: true,
  },
  {
    path: "/influencer/collaborations",
    name: "InfluencerCollaborations",
    title: "My Collaborations",
    element: <InfluencerCollaborations />,
    protected: true,
  },
  {
    path: "/influencer/dashboard",
    name: "InfluencerDashboard",
    title: "Earnings Dashboard",
    element: <InfluencerDashboard />,
    protected: true,
  },
  {
    path: "/influencer/transactions",
    name: "InfluencerTransactions",
    title: "My Transactions",
    element: <InfluencerTransactions />,
    protected: true,
  },
  {
    path: "/influencer/orders",
    name: "InfluencerOrders",
    title: "My Orders",
    element: <InfluencerOrders />,
    protected: true,
  },
  {
    path: "/influencer/transactions/:id",
    name: "TransactionDetail",
    title: "Transaction Details",
    element: <TransactionDetail />,
    protected: true,
  },
  {
    path: "/influencer/payout",
    name: "PayoutRequest",
    title: "Request Payout",
    element: <PayoutRequest />,
    protected: true,
  },
  {
    path: "/influencer/payouts",
    name: "PayoutHistory",
    title: "Payout History",
    element: <PayoutHistory />,
    protected: true,
  },
  {
    path: "/influencer/kyc",
    name: "InfluencerKyc",
    title: "Verification & Payouts",
    element: <InfluencerKyc />,
    protected: true,
  },
  {
    path: "/influencer/promote-deals",
    name: "PromoteDeals",
    title: "Promote Deals",
    element: <PromoteDeals />,
    protected: true,
  },
  {
    path: "/influencer/exclusive-deals",
    name: "ExclusiveDeals",
    title: "Exclusive Deals",
    element: <ExclusiveDeals />,
    protected: true,
  },
  {
    path: "/influencer/drafts",
    name: "InfluencerDrafts",
    title: "My Drafts",
    element: <InfluencerDrafts />,
    protected: true,
  },
  {
    path: "/influencer/create-exclusive-deal",
    name: "CreateExclusiveDeal",
    title: "Create Exclusive Deal",
    element: <CreateExclusiveDeal />,
    protected: true,
    noFooter: true,
  },
  {
    path: "/sent-requests",
    name: "SentRequests",
    title: "Sent Requests",
    element: <MerchantProposals />,
    protected: true,
  },
  {
    path: "/deals-details/:id",
    name: "DealsDetails",
    title: "Deals Details",
    element: <DealsDetails />,
    protected: true,
  },
];

// Routes only for merchant role
const merchantRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    title: "Dashboard",
    element: <Dashboard />,
    protected: true,
  },
  {
    path: "/reports",
    name: "Reports",
    title: "Reports",
    element: <Reports />,
    protected: true,
  },
  {
    path: "/",
    name: "Home",
    title: "Home",
    element: <Profile />,
    protected: true,
  },
  {
    path: "/upload",
    name: "Upload",
    title: "Upload",
    element: <Upload />,
    protected: true,
  },


  {
    path: "/deals",
    name: "Deals",
    title: "Create Deal",
    element: <Deals />,
    protected: true,
    noFooter: true,
  },
  {
    path: "/deals/:dealId/edit",
    name: "DealEdit",
    title: "Edit Deal",
    element: <DealEdit />,
    protected: true,
    noFooter: true,
  },
  {
    path: "/merchant/commissions",
    name: "MerchantCommissionDashboard",
    title: "Commission Dashboard",
    element: <MerchantCommissionDashboard />,
    protected: true,
  },
  {
    path: "/merchant/transactions",
    name: "MerchantTransactions",
    title: "Commission Transactions",
    element: <MerchantTransactions />,
    protected: true,
  },
  {
    path: "/merchant/payouts",
    name: "MerchantPayoutHistory",
    title: "Payout History",
    element: <MerchantPayoutHistory />,
    protected: true,
  },
  {
    path: "/collaboration-proposal/:dealId",
    name: "CollaborationProposal",
    title: "Collaboration Proposal",
    element: <CollaborationProposal />,
    protected: true,
  },
  {
    path: "/sent-requests",
    name: "SentRequests",
    title: "Sent Requests",
    element: <MerchantProposals />,
    protected: true,
  },
  {
    path: "/merchant/proposals",
    name: "MerchantProposals",
    title: "My Proposals",
    element: <MerchantProposals />,
    protected: true,
  },
  {
    path: "/orders",
    name: "Orders",
    title: "Order Management",
    element: <Orders />,
    protected: true,
  },
  {
    path: "/order/:id",
    name: "OrderDetails",
    title: "Order Details",
    element: <OrderDetails />,
    protected: true,
  },
  {
    path: "/incoming-requests",
    name: "IncomingRequests",
    title: "Incoming Requests",
    element: <Proposals />,
    protected: true,
  },
  {
    path: "/deals-details/:id",
    name: "DealsDetails",
    title: "Deals Details",
    element: <DealsDetails />,
    protected: true,
  },
  {
    path: "/merchant/settings",
    name: "MerchantSettings",
    title: "Settings",
    element: <Navigate to="/?tab=settings" replace />,
    protected: true,
  },
  {
    path: "/merchant/deal-proposals",
    name: "MerchantDealProposals",
    title: "Deal Proposals",
    element: <MerchantDealProposals />,
    protected: true,
  },
];

// Function to get routes based on user role
export const getRoleBasedRoutes = (userRole) => {
  // Routes for influencer role
  if (userRole === "influencer") {
    return [
      ...influencerRoutes,
      ...publicRoutes,
      {
        path: "/*",
        name: "NotFound",
        title: "Page Not Found",
        element: <NotFound />,
      },
    ];
  }

  // Routes for merchant role (default)
  return [
    ...merchantRoutes,
    ...publicRoutes,
    {
      path: "/*",
      name: "NotFound",
      title: "Page Not Found",
      element: <NotFound />,
    },
  ];
};

// Default export for backwards compatibility (merchant routes)
const routes = getRoleBasedRoutes("merchant");

export default routes;
